export default {
  data() {
    return {
      showPrev: false,
      showNext: false,
      item: null,
      loading: true,
    };
  },
  computed: {
    showFavoritePhotos() {
      return this.$store.getters.SHOW_FAVORITE_PHOTO;
    },
    favoritePhotos() {
      if (this.showFavoritePhotos && this.album) {
        const favoriteAlbum = this._.find(this.favorites, {albumId: this.album.id});

        if (favoriteAlbum) {
          let favoriteAlbumItems = [];

          favoriteAlbumItems = this.albumPhotos.filter(photo => {
            return !!this._.find(favoriteAlbum.items, {photoId: photo.id});
          });

          if (favoriteAlbumItems.length > 0) {
            return favoriteAlbumItems;
          }
        }
      }

      return this.albumPhotos;
    },
    orderedPhotos() {
      return this.$store.getters.ORDERED_PHOTOS;
    },
  },
  methods: {
    prev(currentId, execute = true) {
      let albumPhotos = this.favoritePhotos;

      const currentIndex = this._.findIndex(albumPhotos, {id: currentId});
      const prevIndex = currentIndex === 0
          ? albumPhotos.length - 1
          : currentIndex - 1;
      const prevIndex2 = prevIndex === 0 ? albumPhotos.length - 1 : prevIndex -
          1;

      const photos = albumPhotos[execute ? prevIndex2 : prevIndex];
      const src = photos && photos.large_photo ? photos.large_photo : '';

      if (this.isCached(src)) {
        this.showPrev = true;
      } else {
        this.showPrev = false;
        this.loadPhoto(src, 'prev');
      }

      if (execute && albumPhotos[prevIndex]) {
        this.$store.dispatch('SET_PHOTO', albumPhotos[prevIndex]);

        if (albumPhotos[prevIndex].id) {
          this.$router.push(this.i18nLink(
              `album/gallery/${this.getAlbumId()}/order/${albumPhotos[prevIndex].id}`));
        }
      }
    },
    next(currentId, execute = true) {
      let albumPhotos = this.favoritePhotos;

      const currentIndex = this._.findIndex(albumPhotos, {id: currentId});
      const nextIndex = currentIndex === albumPhotos.length - 1
          ? 0
          : currentIndex + 1;
      const nextIndex2 = nextIndex === albumPhotos.length - 1 ? 0 : nextIndex +
          1;

      const photos = albumPhotos[execute ? nextIndex2 : nextIndex];
      const src = photos && photos.large_photo ? photos.large_photo : '';

      if (this.isCached(src)) {
        this.showNext = true;
      } else {
        this.showNext = false;
        this.loadPhoto(src, 'next');
      }

      if (execute && albumPhotos[nextIndex]) {
        this.$store.dispatch('SET_PHOTO', albumPhotos[nextIndex]);

        if (albumPhotos[nextIndex].id) {
          this.$router.push(this.i18nLink(
              `album/gallery/${this.getAlbumId()}/order/${albumPhotos[nextIndex].id}`));
        }
      }
    },
    getAlbumId() {
      return this.album.status === '2'
          ? `${this.album.hash}-${this.album.hash_password}`
          : this.album.id;
    },
    loadPhoto(src, action = 'prev') {
      const img = new Image(0, 0);

      img.src = src;
      img.onload = () => action === 'next'
          ? this.showNext = true
          : this.showPrev = true;
    },
    isCached(src) {
      const image = new Image();
      image.src = src;

      return image.complete;
    },
    isFavorite(id) {
      const albumIndex = this.favorites ? this._.findIndex(this.favorites,
          {albumId: this.album ? this.album.id : 0}) : 0;

      if (albumIndex >= 0) {
        return this.favorites ? !!this._.find(this.favorites[albumIndex].items,
            {photoId: id}) : false;
      }

      return false;
    },
  },
  created() {
    if (this.photo) {
      this.prev(this.photo.id, false);
      this.next(this.photo.id, false);
    } else {
      this.$router.push(this.i18nLink(`album/gallery/${this.getAlbumId()}`));
      this.$store.dispatch('DROP_ORDER');
    }
  },
};
